export var GroundFlags = {
  GROUND_UNFINISHED: 0,
  GROUND_FINISHED: 1,
  GROUND_RENDERED: 2 };